import React, { Component, Fragment } from 'react';
import { Button, Icon, Result, Modal, Switch } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { debounce } from 'lodash';
import { withTranslation } from "react-i18next";
import DEFINE, { PATHS } from "../../../../../constants/Define";
import * as Func from '../../../../../helpers/functions';
import { PageListComponent, HeaderListComponent, ListComponent, FilterDropdown } from "../../../common/component/Index";
import Ripple from '../../../common/component/Ripple';
import { FlagIcons } from "../../../common/component/TranslateButton";
import { getMenus, getOutlets, syncMenuItems, syncMenus, updateMenu } from '../../../../../actions/fnbAction';
import Wrapper from "containers/backend/common/component/Wrapper";
import AntSelect, { AntOption } from "containers/backend/common/component/AntSelect";
import Span from "containers/backend/common/component/Span";

let permisionActions = {};
const pageSize = 10;
const outletPageSize = 20;

class Menu extends Component {
    state = {
        filters: {
            PageIndex: 1,
            PageSize: pageSize,
            Level: 1,
        },
        outletId: null,
        outletPropertyId: null,
        outletSearchTerm: '',
    };

    searchOutletsDebounced = debounce((searchTerm) => {
        this.props.actions.getOutlets(Func.removeObjectNull({
            PageIndex: 1,
            PageSize: outletPageSize,
            SearchTerm: searchTerm || undefined,
        }));
    }, 400);

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU);
        
        if (!permisionActions || !permisionActions.allowView) {
            return;
        }
        this.props.actions.getOutlets({ PageIndex: 1, PageSize: outletPageSize });
        this.props.actions.getMenus(this.state.filters);
    }

    componentWillUnmount() {
        this.searchOutletsDebounced.cancel();
    }

    buildFilters = (pagination, filters, sorter) => {
        const currentFilters = this.state.filters || {};
        const hasNameKey = Object.prototype.hasOwnProperty.call(filters || {}, 'name');
        const hasCodeKey = Object.prototype.hasOwnProperty.call(filters || {}, 'code');
        const hasStatusKey = Object.prototype.hasOwnProperty.call(filters || {}, 'isActive');
        const hasLevelKey = Object.prototype.hasOwnProperty.call(filters || {}, 'level');
        const nameFilterRaw = filters?.name;
        const codeFilterRaw = filters?.code;
        const statusFilterRaw = filters?.isActive;
        const levelFilterRaw = filters?.level;
        const nameFilter = Array.isArray(nameFilterRaw) ? nameFilterRaw[0] : undefined;
        const codeFilter = Array.isArray(codeFilterRaw) ? codeFilterRaw[0] : undefined;
        const statusFilter = Array.isArray(statusFilterRaw) ? statusFilterRaw[0] : undefined;
        const levelFilter = Array.isArray(levelFilterRaw) ? levelFilterRaw[0] : undefined;
        const nameEmpty = typeof nameFilter === 'string' && nameFilter.trim() === '';
        const codeEmpty = typeof codeFilter === 'string' && codeFilter.trim() === '';
        const levelEmpty = levelFilter === '' || levelFilter === null || levelFilter === undefined;
        const nameCleared = (hasNameKey && Array.isArray(nameFilterRaw) && nameFilterRaw.length === 0) || nameEmpty;
        const codeCleared = (hasCodeKey && Array.isArray(codeFilterRaw) && codeFilterRaw.length === 0) || codeEmpty;
        const statusCleared = hasStatusKey && Array.isArray(statusFilterRaw) && statusFilterRaw.length === 0;
        const levelCleared = (hasLevelKey && Array.isArray(levelFilterRaw) && levelFilterRaw.length === 0) || levelEmpty;
        const searchTerm = nameCleared || codeCleared
            ? undefined
            : nameFilter !== undefined && !nameEmpty
                ? nameFilter
                : codeFilter !== undefined && !codeEmpty
                    ? codeFilter
                    : currentFilters.SearchTerm;
        const isActive = statusCleared ? undefined : (statusFilter !== undefined ? statusFilter : currentFilters.IsActive);
        const levelParsed = levelFilter !== undefined && levelFilter !== '' ? Number(levelFilter) : undefined;
        const levelValue = levelCleared
            ? undefined
            : levelFilter !== undefined && levelFilter !== '' && !Number.isNaN(levelParsed)
                ? levelParsed
                : currentFilters.Level;
        const orderBy = sorter?.order ? sorter.field : undefined;
        const orderByDesc = sorter?.order ? sorter.order === 'descend' : undefined;
        const pageIndex = pagination?.current || currentFilters.PageIndex || 1;
        const pageSizeValue = pagination?.pageSize || currentFilters.PageSize || pageSize;
        const changedFilters =
            searchTerm !== currentFilters.SearchTerm ||
            isActive !== currentFilters.IsActive ||
            levelValue !== currentFilters.Level ||
            orderBy !== currentFilters.OrderBy ||
            orderByDesc !== currentFilters.OrderByDesc;
        const nextFilters = Func.removeObjectNull({
            PageIndex: changedFilters ? 1 : pageIndex,
            PageSize: pageSizeValue,
            SearchTerm: searchTerm,
            IsActive: isActive,
            FnbOutletId: currentFilters.FnbOutletId,
            Level: levelValue,
            OrderBy: orderBy,
            OrderByDesc: orderByDesc,
        });
        return nextFilters;
    };

    handleChange = (pagination, filters, sorter) => {
        const nextFilters = this.buildFilters(pagination, filters, sorter);
        this.setState({ filters: nextFilters });
        this.props.actions.getMenus(nextFilters);
    }

    buildUpdateStatusPayload = (record, isActive) => ({
        ...record,
        isActive,
        status: isActive ? 1 : 0,
    });

    handleUpdateStatus = (record, checked) => {
        const { t } = this.props;
        if (!record?.id) {
            return;
        }

        Modal.confirm({
            title: t('item.fnb.menu.status'),
            content: checked
                ? 'Bạn có chắc chắn muốn kích hoạt menu này?'
                : 'Bạn có chắc chắn muốn tắt menu này?',
            okText: t('action.confirm') || 'Xác nhận',
            cancelText: t('action.cancel') || 'Hủy',
            onOk: () => {
                this.props.actions.updateMenu({
                    id: record.id,
                    updatePayload: this.buildUpdateStatusPayload(record, checked),
                    filters: this.state.filters,
                });
            },
        });
    };

    formatOutlets = (outlets, record) => {
        const outletList = Array.isArray(outlets) ? outlets : [];
        const names = outletList
            .map((outlet) => outlet?.name || outlet?.outletName || outlet?.code || outlet?.id)
            .filter(Boolean);
        if (names.length) {
            return names.join(', ');
        }
        return record?.fnbOutletId || record?.outletId || record?.outlet || '';
    };

    onChangeOutlet = (value) => {
        const { outlets } = this.props;
        const selectedOutlet =
            (outlets || []).find((outlet) => outlet?.id === value) || null;
        const selectedPropertyId =
            selectedOutlet?.propertyId ||
            selectedOutlet?.property?.id ||
            selectedOutlet?.property?.propertyId ||
            null;

        const nextFilters = Func.removeObjectNull({
            ...this.state.filters,
            PageIndex: 1,
            FnbOutletId: value ?? null,
        });
        this.setState({
            filters: nextFilters,
            outletId: value ?? null,
            outletPropertyId: selectedPropertyId,
        });
        this.props.actions.getMenus(nextFilters);
    };

    handleOutletSearch = (value) => {
        const outletSearchTerm = typeof value === 'string' ? value.trim() : '';
        this.setState({ outletSearchTerm });
        this.searchOutletsDebounced(outletSearchTerm);
    };

    hasMoreOutlets = () => {
        const { outletsPagination } = this.props;
        if (!outletsPagination) {
            return false;
        }
        const pageIndex = Number(outletsPagination.pageIndex) || 1;
        const pageSizeValue = Number(outletsPagination.pageSize) || outletPageSize;
        const totalCount = Number(outletsPagination.totalCount) || 0;
        return pageIndex * pageSizeValue < totalCount;
    };

    handleOutletPopupScroll = (event) => {
        const { outletsLoading } = this.props;
        if (outletsLoading || !this.hasMoreOutlets()) {
            return;
        }
        const target = event?.target;
        if (!target) {
            return;
        }
        const threshold = 32;
        const reachedBottom =
            target.scrollTop + target.offsetHeight >= target.scrollHeight - threshold;
        if (reachedBottom) {
            const { outletsPagination } = this.props;
            const { outletSearchTerm } = this.state;
            const nextPageIndex = (Number(outletsPagination?.pageIndex) || 1) + 1;
            this.props.actions.getOutlets({
                params: Func.removeObjectNull({
                    PageIndex: nextPageIndex,
                    PageSize: outletPageSize,
                    SearchTerm: outletSearchTerm || undefined,
                }),
                append: true,
            });
        }
    };

    render() {
        const { t, menus, loading, menusPagination, error, outlets, outletsLoading, menuSyncing, menuItemSyncing } = this.props;
        const { filters, outletId, outletPropertyId } = this.state;
        
        if (!permisionActions || !permisionActions.allowView) {
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle={t('item.fnb.menu.unauthorized') || "Bạn không có quyền truy cập vào khu vực này"}
                />
            );
        }
        
        // Hiển thị error nếu API trả về lỗi 403 (backend permission check failed)
        if (error && error.status === 403) {
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle="Backend API trả về 403. Vui lòng kiểm tra permission ở backend hoặc liên hệ quản trị viên."
                    extra={
                        <Button type="primary" onClick={() => window.location.reload()}>
                            Tải lại trang
                        </Button>
                    }
                />
            );
        }
        
        const canSync = permisionActions && permisionActions.allowSync;
        const columns = [
            {
                title: t('item.fnb.menu.code'),
                dataIndex: 'code',
                key: 'code',
                sorter: true,
            },
            {
                title: t('item.fnb.menu.name'),
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                filteredValue: filters.SearchTerm ? [filters.SearchTerm] : null,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    />
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => (
                    <Link
                        to={{
                            pathname: Func.getPathWithParams(PATHS.FNB.MENU_MANAGER.SUB_MENU.path, { id: record.id }),
                            state: {
                                menuName: record.name,
                                outletId,
                                outletPropertyId,
                            },
                        }}
                        className="colorPrimary"
                    >
                        {text}
                    </Link>
                )
            },
            {
                title: 'Level',
                dataIndex: 'level',
                key: 'level',
                sorter: true,
                filteredValue: filters.Level !== undefined ? [filters.Level] : null,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                        inputType="number"
                        inputProps={{ min: 0, step: 1 }}
                    />
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            {
                title: t('item.fnb.menu.outlet'),
                dataIndex: 'outlets',
                key: 'outlets',
                render: (outlets, record) => this.formatOutlets(outlets, record),
            },
            {
                title: t('item.fnb.menu.translations'),
                dataIndex: 'translations',
                key: 'translations',
                render: (translations) => <FlagIcons languages={translations || []} />
            },
            {
                title: t('item.fnb.menu.status'),
                dataIndex: 'isActive',
                key: 'isActive',
                filters: [
                    { value: true, text: t('item.fnb.menu.active') },
                    { value: false, text: t('item.fnb.menu.inactive') },
                ],
                filterMultiple: false,
                filteredValue: filters.IsActive !== undefined ? [filters.IsActive] : null,
                render: (isActive, record) => {
                    const active =
                        typeof isActive === 'boolean' ? isActive : Boolean(record.status);
                    const canUpdate = permisionActions && permisionActions.allowUpdate;
                    return (
                        <Switch
                            checked={active}
                            disabled={!canUpdate || this.props.menuUpdateLoading}
                            checkedChildren={t('item.fnb.menu.active')}
                            unCheckedChildren={t('item.fnb.menu.inactive')}
                            onChange={(checked) => this.handleUpdateStatus(record, checked)}
                        />
                    );
                }
            },
            {
                title: t('action.action'),
                key: 'action',
                align: 'right',
                render: (text, record) => (
                    <Link to={Func.getPathWithParams(PATHS.FNB.MENU_MANAGER.DETAIL.path, { id: record.id })}>
                        <Icon type="form" className="fs20 colorPrimary" />
                    </Link>
                )
            },
        ];

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        titleHeader={t('navigation.menu')}
                        extraBreadcrumbs={[{ title: t('navigation.menu') }]}
                        componentRight={
                            canSync && outletId ? (
                                <Fragment>
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button
                                            icon="sync"
                                            className="btn btn-primary mr-2"
                                            loading={menuSyncing}
                                            onClick={this.onSync}
                                        >
                                            {t('action.sync')}
                                        </Button>
                                    </Ripple>
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button
                                            icon="sync"
                                            className="btn btn-primary"
                                            loading={menuItemSyncing}
                                            onClick={this.onSyncMenuItems}
                                        >
                                            {t('action.syncMenuItems') || 'Sync menu items'}
                                        </Button>
                                    </Ripple>
                                </Fragment>
                            ) : null
                        }
                    />
                    <Wrapper className="row col-md-12 p-2" style={{ marginBottom: "1rem" }}>
                        <Wrapper className="col-md-4">
                            <Span>{t('item.fnb.menu.outlet')}:</Span>
                            <AntSelect
                                className="select-departure"
                                showArrow
                                showSearch
                                allowClear
                                placeholder={t('item.fnb.menu.outlet')}
                                value={outletId}
                                onChange={this.onChangeOutlet}
                                style={{ width: "100%" }}
                                filterOption={false}
                                onSearch={this.handleOutletSearch}
                                onPopupScroll={this.handleOutletPopupScroll}
                                loading={outletsLoading}
                            >
                                <AntOption value={null}>Tất cả</AntOption>
                                {(outlets || []).map((outlet) => (
                                    <AntOption key={outlet.id} value={outlet.id}>
                                        {outlet.name || outlet.outletName || outlet.code || outlet.id}
                                    </AntOption>
                                ))}
                            </AntSelect>
                        </Wrapper>
                    </Wrapper>
                    <ListComponent
                        tableKey="menu-list"
                        classChildren="p-0"
                        classParent="m-0"
                        rowKey={(record, index) => record.id || index}
                        loading={{ spinning: loading, size: "large" }}
                        dataSource={menus || []}
                        columns={columns}
                        onChange={this.handleChange}
                        pagination={{
                            total: menusPagination?.totalCount || 0,
                            totalPage: menusPagination?.totalPage || 0,
                            defaultCurrent: menusPagination?.pageIndex || 1,
                            defaultPageSize: menusPagination?.pageSize || pageSize,
                        }}
                    />
                </PageListComponent>
            </Fragment>
        );
    }

    onSync = () => {
        const { t } = this.props;
        const { outletId, outletPropertyId, filters } = this.state;
        if (!outletId) {
            return;
        }
        Modal.confirm({
            title: t('action.sync'),
            content: t('notification.confirmSyncData') || 'Bạn có chắc chắn muốn đồng bộ dữ liệu menu cho outlet này?',
            okText: t('action.confirm') || 'Xác nhận',
            cancelText: t('action.cancel') || 'Hủy',
            onOk: () => {
                this.props.actions.syncMenus({
                    outletId,
                    propertyId: outletPropertyId,
                    filters,
                });
            },
        });
    };

    onSyncMenuItems = () => {
        const { t } = this.props;
        const { outletId, outletPropertyId, filters } = this.state;
        if (!outletId) {
            return;
        }
        Modal.confirm({
            title: t('action.syncMenuItems') || 'Sync menu items',
            content: t('notification.confirmSyncData') || 'Bạn có chắc chắn muốn đồng bộ dữ liệu menu cho outlet này?',
            okText: t('action.confirm') || 'Xác nhận',
            cancelText: t('action.cancel') || 'Hủy',
            onOk: () => {
                this.props.actions.syncMenuItems({
                    outletId,
                    propertyId: outletPropertyId,
                    filters,
                });
            },
        });
    };
}

const mapStateToProps = (state) => ({
    menus: state.fnbReducer.menus,
    menusPagination: state.fnbReducer.menusPagination,
    loading: state.fnbReducer.loading,
    outlets: state.fnbReducer.outlets,
    outletsPagination: state.fnbReducer.outletsPagination,
    outletsLoading: state.fnbReducer.outletsLoading,
    menuSyncing: state.fnbReducer.menuSyncing,
    menuItemSyncing: state.fnbReducer.menuItemSyncing,
    menuUpdateLoading: state.fnbReducer.menuUpdateLoading,
    error: state.fnbReducer.error,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getMenus,
            getOutlets,
            syncMenus,
            syncMenuItems,
            updateMenu,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Menu));
